import { userStore } from "$lib/stores/user";
import { isAxiosError } from "axios";
import { createRedirectParams } from "$lib/utils/http/url";

let isRedirecting = false;

export function handleUnauthorizedResponse(
  response: Pick<Response, "status">,
): void {
  if (
    response.status === 401 &&
    window.location.pathname !== "/login" &&
    !isRedirecting
  ) {
    isRedirecting = true;
    userStore.logout().finally(() => {
      const redirectParams = createRedirectParams(
        window.location.pathname,
        window.location.search,
      );
      window.location.assign(`/login${redirectParams}`);
      isRedirecting = false;
    });
  }
}

export function handleUnauthorized(error: unknown) {
  if (isAxiosError(error) && error.response) {
    handleUnauthorizedResponse(error.response);
  }
  return Promise.reject(error);
}
